import type { Prompt, PromptTypeType } from '../../../types/backend';

// Which bucket of the Studio owns a prompt. Every prompt belongs to exactly one.

const INSTRUCTION_TYPES: PromptTypeType[] = ['playbook', 'system_prompt', 'automation_prompt', 'enrichment', 'report'];
const SKILL_TYPES: PromptTypeType[] = ['skill', 'learned_skill'];

// Mirrors the backend ACCOUNT_MODEL_PROMPT_NAME: the shared account-model primer is
// system_prompt-typed but belongs to no agent, so it is not a shell. Without this it would
// lose its only home, since the Agents bucket owns the shells.
export const ACCOUNT_MODEL_PROMPT_NAME = 'account_model';

export const isSkillPrompt = (p: Prompt): boolean => SKILL_TYPES.includes(p.type as PromptTypeType);

/** An agent's system-prompt shell, edited under its agent rather than among the instructions. */
export const isAgentShellPrompt = (p: Prompt): boolean =>
  p.type === 'system_prompt' && p.name !== ACCOUNT_MODEL_PROMPT_NAME;

export const isInstructionPrompt = (p: Prompt): boolean =>
  INSTRUCTION_TYPES.includes(p.type as PromptTypeType) && !isAgentShellPrompt(p);
